
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { SelectType } from "@/common/components";
import PFormSelectNarrow from "./PFormSelectNarrow.vue";
import PFormCheckBox from "../PFormCheckBox/PFormCheckBox.vue";
import PButton from "../PButton/PButton.vue";
import PDropDownContainer from "../PDropDownContainer/PDropDownContainer.vue";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";
import { PFormSelectTranslations, translations } from "./pFormSelectLanguages";
import { PFormSelectMultiFilterTranslation } from "./pFormSelect.types";

@Component({
  components: {
    PFormCheckBox,
    PFormSelectNarrow,
    PDropDownContainer,
    PButton,
    PIcon,
  },
})
export class PFormSelectMultiFilter extends Vue {
  @Prop({ required: true }) value!: string[];
  @Watch("value", { deep: true, immediate: true })
  onChangeValue(): void {
    this.fillValueTempInitial();
    this.fillViewInput();
    this.allCheck = this.areAllChecked(this.valueTemp);
  }

  @Prop({ required: false, default: "" }) label!: string;
  @Prop({ required: true }) options!: SelectType[];
  @Prop({ required: true }) filterProperties!: SelectType[];
  @Prop({ required: false, default: undefined }) state!: boolean;
  @Prop({ required: false, default: undefined }) invalidFeedback!: string;
  @Prop({ required: false }) translation!: PFormSelectMultiFilterTranslation;
  @Prop({ required: false, default: "es" }) language!: string;

  @Watch("pussOption")
  onChangePussOption(): void {
    if (this.pussOption) {
      this.fillValueTempInitial();
      this.fillViewInput();
      this.allCheck = this.areAllChecked(this.valueTemp);
    }
  }

  @Watch("options")
  onChangeOptions(): void {
    this.emptyValueTemp();
    this.fillValueTempInitial();
    this.fillViewInput();
    this.allCheck = this.areAllChecked(this.valueTemp);
  }

  @Watch("filterOptions")
  onFilterOptions(): void {
    // keep the "select all" checkbox reflecting visible items
    this.allCheck = this.areAllChecked(this.valueTemp);
  }

  selectItemFilterProperty = "";
  allCheck = false;
  valueTemp: string[] = [];
  viewInput = { firstSelectedText: "", more: "" };
  filterOptions = "";
  pussOption = false;
  translator: PFormSelectTranslations = translations[0].translations;

  created(): void {
    const language = this.language.split("-").shift();
    const translation = translations.find((tran) => tran.language === language)?.translations;
    if (translation) this.translator = translation;
    if (this.translation) this.translator = Object.assign({}, this.translator, this.translation);
  }

  mounted(): void {
    if (this.filterProperties.length > 0) {
      this.selectItemFilterProperty = this.filterProperties[0].value as string;
    }
    this.fillValueTempInitial();
    this.allCheck = this.areAllChecked(this.valueTemp);
  }

  // -------- helpers --------

  indexByValue(val: any): number {
    const str = String(val);
    return this.options.findIndex((op) => String(op.value) === str);
  }

  get placeholderSearch(): string {
    const filterOn = this.filterProperties.find((filter) => filter.value === this.selectItemFilterProperty);
    return filterOn ? this.translator.textFilterOn + " " + filterOn.text : this.translator.textSelectWhatFilterBy;
  }
  get optionsComp(): SelectType[] {
    const term = (this.filterOptions ?? "").trim().toLowerCase();
    if (term) {
      return this.options.filter((op) => {
        const txt = (op.text ?? "").toString().toLowerCase();
        const norm = txt.normalize("NFD").replace(/\p{Diacritic}/gu, "");
        return txt.includes(term) || norm.includes(term);
      });
    }
    return this.options;
  }

  changeOptions(): void {
    this.allCheck = this.areAllChecked(this.valueTemp);
  }

  areAllChecked(arr: string[]): boolean {
  // Only consider VISIBLE options
  const visible = this.optionsComp;
  if (visible.length === 0) return false;
  return visible.every(op => {
    const idx = this.indexByValue(op.value);
    return idx > -1 && arr[idx] !== "";
  });
}

  fillValueTempInitial(): void {
    // ensure valueTemp has one slot per original option (stable by original index)
    this.options.forEach((op, index) => {
      const isSelected = this.value.findIndex((val) => String(val) === String(op.value)) > -1;
      this.$set(this.valueTemp, index, isSelected ? String(op.value) : "");
    });
    // trim excess if options shrank
    if (this.valueTemp.length > this.options.length) {
      this.valueTemp.splice(this.options.length);
    }
  }

  emptyValueTemp(): void {
    this.unSelect();
  }

  fillViewInput(): void {
    this.viewInput.more = "";
    this.viewInput.firstSelectedText = this.translator.textNoFilter;
    const valueTempFill = this.valueTemp.filter((val) => val != "");
    if (valueTempFill.length > 0) {
      const opt = this.options.find((op) => String(op.value) === String(valueTempFill[0]));
      this.viewInput.firstSelectedText = opt ? " " + opt.text : this.translator.textNoFilter + "";
    }
    if (valueTempFill.length > 1) {
      this.viewInput.more = " +" + (valueTempFill.length - 1) + " " + this.translator.textMore;
    }
  }

  search(str: string): void {
    const idx = this.indexByValue(str);
    if (idx > -1) this.$set(this.valueTemp, idx, String(this.options[idx].value));
    else console.error("Options de PFormSelectMultiFilter no coinciden con los del _PFormSelectMultiFilter");
  }

  showOptions(): void {
    this.pussOption = true;
  }

  apply(): void {
    this.pussOption = false;
    this.fillViewInput();
    this.$emit("input", [...this.valueTemp]);
  }

  unSelect(): void {
    this.options.forEach((_, index) => {
      this.$set(this.valueTemp, index, "");
    });
    this.allCheck = false;
  }

  selectAll(): void {
  this.$nextTick(() => {
    const shouldCheckAll = !!this.allCheck;

    // Toggle ONLY VISIBLE options
    this.optionsComp.forEach(op => {
      const idx = this.indexByValue(op.value);
      if (idx > -1) {
        this.$set(this.valueTemp, idx, shouldCheckAll ? String(op.value) : "");
      }
    });

    this.fillViewInput();
    // Keep header checkbox reflecting the VISIBLE set
    this.allCheck = this.areAllChecked(this.valueTemp);
  });
}
}
export default PFormSelectMultiFilter;
